import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Box, CircularProgress, Modal } from '@mui/material';

import PreviewModal from 'components/PreviewModal/PreviewModal';

import { getFAQById, resetFAQDetails } from 'store/reducers/faqsSlice';

const PreviewFAQ = memo(({ openModal, onCloseModal, selectedFAQ }) => {
  const dispatch = useDispatch();

  const [isFetchingFAQ, setFetchingFAQ] = useState(false);

  const { faqDetails } = useSelector((state) => state.faqs);

  async function fetchFAQ() {
    try {
      setFetchingFAQ(true);
      await dispatch(getFAQById(selectedFAQ?.id));
    } catch (error) {
      console.log({ error });
      onCloseModal();
    } finally {
      setFetchingFAQ(false);
    }
  }

  useEffect(() => {
    if (selectedFAQ?.id) {
      fetchFAQ();
    }
  }, [selectedFAQ]);

  useEffect(() => {
    return () => {
      dispatch(resetFAQDetails());
    };
  }, []);

  return (
    <Modal
      open={openModal}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;
        onCloseModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEscapeKeyDown
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          overflow: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
          maxHeight: 'calc(100vh - 100px)',
          maxWidth: 'calc(100vw - 24px)',
          minWidth: isFetchingFAQ ? 'min(90vw, 800px)' : 'unset',
          minHeight: isFetchingFAQ ? 'min(90vh, 800px)' : 'unset',
        }}
      >
        {isFetchingFAQ ? (
          <Box
            sx={{
              minHeight: 'min(80vh, 800px)',
              display: 'grid',
              placeItems: 'center',
            }}
          >
            <CircularProgress color="info" />
          </Box>
        ) : (
          <PreviewModal
            modalTitle={faqDetails?.question}
            modalContent={faqDetails?.content ?? <p>No Content</p>}
            onCloseModal={onCloseModal}
          />
        )}
      </Box>
    </Modal>
  );
});

PreviewFAQ.propTypes = {
  openModal: PropTypes.bool,
  onCloseModal: PropTypes.func,
  selectedFAQ: PropTypes.object,
};

PreviewFAQ.defaultProps = {
  openModal: false,
  onCloseModal: () => {},
  selectedFAQ: null,
};
export default PreviewFAQ;
